import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueAuth from '@websanova/vue-auth';
import NProgress from 'vue-nprogress';
import { sync } from 'vuex-router-sync';
// import Cleave from 'cleave.js';

import App from './App.vue';
import router from './router';
import store from './store';
import * as filters from './filters';
import { TOGGLE_SIDEBAR, TOGGLE_NAVBAR_MENU } from 'vuex-store/mutation-types';
import Notification from 'vue-bulma-notification';
import messages from './lang'

const NotificationComponent = Vue.extend(Notification);
const openNotification = (
  propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications',
  }
) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData,
  });
};

const authProdBackend = 'https://iridi.com'

let backendEndpoint = window.location.hostname
if (backendEndpoint.startsWith('localhost')) {
  backendEndpoint = `${backendEndpoint}:3000`
} else {
  backendEndpoint = `${backendEndpoint.replace('byod','byodbackend')}`
}
backendEndpoint = `${window.location.protocol}//${backendEndpoint}`

Vue.prototype.$backendHost = backendEndpoint

// Vue.directive('cleave', {
//   inserted: (el, binding, vnode) => {
//     console.log(el, binding, vnode)
//       el.cleave = new Cleave(vnode.componentInstance.$refs.input, binding.value || {})
//       console.log(el.cleave)
//       // el.cleave.setRawValue(binding.value.initValue||'')
//   },
//   update: (el) => {
//       const event = new Event('input', {bubbles: true});
//       setTimeout(function () {
//           el.value = el.cleave.properties.result
//           el.dispatchEvent(event)
//       }, 100);
//   }
// })

// $auth $http
Vue.router = router;
Vue.use(VueAxios, axios);
Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      this.options.http._setHeaders.call(this, req, {
        Authorization: 'Bearer ' + token,
      });
    },
    response: function (res) {
      // Get Token from response body
      // console.log(res);
      if (res.data.code === 'InvalidToken') {
        this.logout({
          redirect: 'Home',
          makeRequest: false,
        });

        openNotification({
          title: '',
          message: 'Session is expired',
          type: 'danger',
        });
      } else {
        return res.data.token;
      }
    },
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {
    url: `${authProdBackend}/customer/auth/`,
    fetchUser: false,
  },
  refreshData: {
    enabled: false,
  },
  tokenExpired: () => {
    return false;
  },
});

Vue.use(NProgress);
// Vue.use(VueI18n);
// Enable devtools
Vue.config.devtools = true;

sync(store, router);

const nprogress = new NProgress({
  parent: '.nprogress-container',
});

const { state } = store;

// router.beforeEach((route, redirect, next) => {
//   if (state.app.device.isMobile && state.app.navbar.opened) {
//     store.commit(TOGGLE_NAVBAR_MENU, false);
//   }
//   if (state.app.device.isMobile && state.app.sidebar.opened) {
//     store.commit(TOGGLE_SIDEBAR, false);
//   }
//   next();
// });

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

window.Vue = Vue
console.log(messages)
const i18n = new VueI18n({
  locale: 'en', // установка локализации по умолчанию
  messages // установка сообщений локализаций
})

const app = new Vue({
  i18n,
  router,
  store,
  nprogress,
  ...App,
});

export { app, router, store };



// WEBPACK FOOTER //
// ./client/app.js